export default __webpack_public_path__ + "static/media/2xcell-signature.316f7a88.png";